var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"id":"app-bar","absolute":"","app":"","color":"white"}},[_c('app-bar-path-item'),_c('v-spacer'),_c('app-bar-help-center-button'),_c('app-bar-user-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }